import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
//@ts-ignore
import LKModal, { LKModalContainer, actions as LKModalActions } from 'shared/LKModal'
//@ts-ignore
import CollateralSearch from 'shared/CollateralSearch'
import { translateCollaterals, translateBase } from '../../helpers'

import { BindCollateralModalProps, CollateralData, ContextMenuParamsProps } from '../../types.LoanDetails'
import { linkCollateral } from 'src/store/loan'
import { AppDispatch } from 'src/store/index.d'

const bindCollateralFetcher = 'bindCollateralFetcher'
const bindCollateralModalName = 'bindCollateralModalName'

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  .collateral-search-container {
    height: calc(100% - 40px);
  }

  .collaterals-grid {
    height: 100%;
    min-height: 100px;
  }
`

@withRouter
@LKModalContainer(bindCollateralModalName)
//@ts-ignore
@connect(
  undefined,
  (
    dispatch: AppDispatch,
    {
      //@ts-ignore
      modalInstanceName,
      //@ts-ignore
      match: {
        params: { ID, hash },
      },
      //@ts-ignore
      onFinish,
    },
  ) => ({
    onLinkLoanToCollateral: (CollateralID: string, CollateralHash: string) => {
      //@ts-ignore
      // dispatch([
      //   fetchSFM({
      //     instanceName: bindCollateralFetcher,
      //     callApi: Loan.linkCollateral,
      //     callApiArgs: [ID, hash, CollateralID, CollateralHash],
      //     resolve: onFinish,
      //     reject: (error: { Error: { Message: string; Text: string } }) => {
      //       dispatch(LKModalActions.openError(translateBase(error.Error.Message || error.Error.Text)))
      //     },
      //   }),
      //   LKModalActions.close(modalInstanceName),
      // ])

      //UPDATED API REQUEST loan_oper_api page:linkcollateral
      dispatch(
        linkCollateral({
          LoanID: ID,
          HashSum_LoanID_: hash,
          CollateralID: CollateralID,
          HashSum_CollateralID_: CollateralHash,
        }),
      ).then((response) => {
        if (!linkCollateral.fulfilled.match(response)) {
          dispatch(LKModalActions.openError(translateBase(response.payload as string)))
          return
        }
        onFinish()
      })
      dispatch(LKModalActions.close(modalInstanceName))
    },
  }),
)
class BindCollateralModal extends React.PureComponent<BindCollateralModalProps> {
  onRowDoubleClicked = ({ node: { data } }) => this.props.onLinkLoanToCollateral(data.ID, data.HashSum_CollateralID_)

  getContextMenuItems = (params: ContextMenuParamsProps) => [
    {
      name: translateCollaterals('cmd_select'),
      action: () => this.onRowDoubleClicked(params),
      icon: 'hand',
    },
  ]

  filterResult = (result: CollateralData[]) => {
    const bindedIds = this.props.bindedCollaterals.map((c) => c.ID)
    return result.filter((c) => bindedIds.indexOf(c.ID) === -1)
  }

  render() {
    const { modalInstanceName } = this.props
    return (
      <LKModal name={modalInstanceName} heading={translateCollaterals('frm_collaterals')} size="lg">
        <Wrapper>
          <CollateralSearch
            onRowDoubleClicked={this.onRowDoubleClicked}
            getContextMenuItems={this.getContextMenuItems}
            instanceName="BindCollateralSearchInstance"
            fetcherName="BindCollateralSearchFetcher"
            formName="BindCollateralSearchForm"
            initialValues={{
              searchValue: this.props.fullname,
              status: {
                active: 1,
                expired: 2,
                insured: 0,
                attachedToLoan: 0,
                attachedToActiveLoan: 0,
              },
            }}
            hintAboveMessage={translateCollaterals('lbl_healthy_only')}
            filterResult={this.filterResult}
            destroyOnUnmount
          />
        </Wrapper>
      </LKModal>
    )
  }
}

export const open = (ID, hash) => LKModalActions.open({ name: bindCollateralModalName, ID, hash })

export default BindCollateralModal
